<template>
  <div>
    <div class="text-center mb-5">
      <h1>Vous avez oublié votre mot de passe?</h1>
      <h2 class="lead h4 text-primary">
        pas de problème, entrez votre couriel et consultez votre boite de
        réception.
      </h2>
    </div>
    <b-form @submit.stop.prevent="onSubmit">
      <b-form-group id="email" label="Adresse courriel" label-for="email-input">
        <b-form-input
          id="email-input"
          name="email-input"
          @change="setValue('email', $event)"
          :value="form.email"
          :state="validateState('email')"
          aria-describedby="input-email-live-feedback"
        ></b-form-input>

        <b-form-invalid-feedback id="input-email-live-feedback">
          Ce champ est requis et doit être un courriel valide.
        </b-form-invalid-feedback>
      </b-form-group>

      <div class="d-flex justify-content-end align-items-center">
        <b-btn size="sm" @click="$router.go(-1)" variant="link"
          >retour à la connexion</b-btn
        >
        <b-btn
          pill
          :disabled="authStatus == 'fetching'"
          class="px-4 ml-2"
          type="submit"
          variant="primary"
        >
          <span>Continuer</span>
          <b-spinner
            class="ml-2"
            small
            v-if="authStatus == 'fetching'"
          ></b-spinner
        ></b-btn>
      </div>
    </b-form>
  </div>
</template>

<script>
/**
 * @file       Forgot password component.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */
import { required, email } from "vuelidate/lib/validators";
import { mapActions, mapState } from "vuex";

/**
 * Export the component.
 * 
 * @type  {Object}
 */
export default {
  /**
   * Data used in the component.
   *
   * @return  {Object}
   */
  data() {
    return {
      form: {
        email: null
      }
    };
  },

  /**
   * Vuelidate form validations.
   * 
   * @type  {Object}
   */
  validations: {
    form: {
      email: {
        required,
        email
      }
    }
  },

  /**
   * Computed properties.
   * 
   * @type  {Object}
   */
  computed: {
    ...mapState({
      authStatus: state => state.auth.forgotPassword.status
    })
  },

  /**
   * Methods.
   * 
   * @type  {Object}
   */
  methods: {
    ...mapActions("auth", {
      forgotPassword: "newPassword"
    }),

    /**
     * Sets the form value.
     *
     * @param      {string}  key     The new value
     * @param      {string}  value   The value
     */
    setValue(key, value) {
      this.form[key] = value;
      this.$v.form[key].$touch();
    },

    /**
     * Validate the form state.
     *
     * @param      {string}  name    The input name
     *
     * @return     {bool}  Dirty or not.
     */
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },

    /**
     * Resets the form.
     */
    resetForm() {
      this.form = {
        email: null
      };

      // Reset on next tick
      this.$nextTick(() => {
        this.$v.$reset();
      });
    },

    /**
     * Called on submit.
     */
    onSubmit() {
      this.$v.form.$touch();

      // If any error found, stop the submit
      if (this.$v.form.$anyError) {
        return;
      }

      // Send the forgot password request
      this.forgotPassword(this.form)
        .then(() => {
          // Display a success message
          this.$root.$bvToast.toast(
            "Vérifiez votre boite mails, nous vous avons envoyé un courriel.",
            {
              title: "Succès"
            }
          );

          // Redirects to home page
          this.$router.push({ name: "home" });
        })
        .catch(err => {
          // Display error mesage
          this.$root.$bvToast.toast(err.response.data.message, {
            title: "Erreur",
            variant: "danger"
          });
        });
    }
  }
};
</script>
